import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

import { getAWSRegions } from 'core/state/region/actions'
import { setAPIURLs } from 'app-support/auth/state/actions'
import { useXDomain } from 'app-support/contexts/XDomainContext'

function configureAPIURLs(domain: string) {
  return {
    support: `https://support-api.${domain}`
  }
}

export function AppSetup({ children }: React.PropsWithChildren<{}>) {
  const dispatch = useDispatch()
  const xDomain = useXDomain()

  React.useEffect(() => {
    const URLs = configureAPIURLs(xDomain)

    dispatch(setAPIURLs(URLs))
  }, [])

  const AWSRegions = useQuery(
    ['aws-regions'],
    async () => {
      return dispatch(getAWSRegions())
    },
    { refetchOnWindowFocus: false }
  )

  if (!AWSRegions.data) {
    return null
  }

  // TypeScript compiler will complain if we don't add JSX fragments.
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
